// extracted by css-extract-rspack-plugin
export default {"root":"root-es1agg","select":"select-HI9Asr"};